import React, { useEffect } from "react";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import { TypeAnimation } from "react-type-animation";
import ReactHtmlParser, {
  processNodes,
  convertNodeToElement,
  htmlparser2,
} from "react-html-parser";
import WhiteNavbar from "components/Navbars/WhiteNavbar";
import { Button, Card, CardTitle, Col, Container, Row } from "reactstrap";
import { AiFillBackward, AiFillForward } from "react-icons/ai";
import { Link, useParams } from "react-router-dom";
import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import "../../assets/css/content-styles.css";
import { Helmet } from "react-helmet-async";
import Footer from "components/Footers/Footer";


const PostFrameworkUpdated = ({ post, posts }) => {
  const [modal, setModal] = React.useState(false);
  const [toggled, setToggled] = React.useState(null);
  const [toggleWidth, setToggleWidth] = React.useState(false);
  const [blogLinkIndex, setBlogLinkIndex] = React.useState(null);
  const [previousPost, setPreviousPost] = React.useState();
  const [nextPost, setNextPost] = React.useState();
  // console.log(last);
  // const toogleRespnsiveFunction = () => {
  //   if(window.innerWidth)
  // }
  const reversedData = [...posts].reverse();

  useEffect(() => {
    function nextItem(array, currentItem) {
      const currentIndex = array.indexOf(currentItem); // Geçerli öğenin dizideki indeksi
      if (currentIndex === -1 || currentIndex === array.length - 1) {
        // Geçerli öğe dizide bulunmuyor veya son öğe ise
        return null; // Sonraki öğe yok, null döndür
      } else {
        return array[currentIndex + 1]; // Sonraki öğeyi döndür
      }
    }

    function previousItem(array, currentItem) {
      const currentIndex = array.indexOf(currentItem); // Geçerli öğenin dizideki indeksi
      if (currentIndex === -1 || currentIndex === 0) {
        // Geçerli öğe dizide bulunmuyor veya ilk öğe ise
        return null; // Önceki öğe yok, null döndür
      } else {
        return array[currentIndex - 1]; // Önceki öğeyi döndür
      }
    }
    setPreviousPost(previousItem(posts, post));
    setNextPost(nextItem(posts, post));
  }, [posts, post]);

  const handleResize = () => {
    if (window.innerWidth < 1200) {
      setToggleWidth(true); // Renamed state variable
    } else {
      setToggleWidth(false); // Renamed state variable
    }
  };

  React.useEffect(() => {
    handleResize(); // Set initial state based on window width
    window.addEventListener("resize", handleResize); // Add event listener for window resize
    return () => {
      window.removeEventListener("resize", handleResize); // Clean up event listener
    };
  }, []);
  // console.log(toggled)

  const toggleModal = () => {
    setModal(!modal);
  };

  const keywords = post?.meta_description
    ? post?.meta_description.split(",").map((keyword) => keyword.trim())
    : [];

  return (
    <div style={{}}>
      <Helmet>
        <title>{post?.meta_title}</title>
        {/* Meta Description */}
        <meta name="description" content={post?.meta_description} />

        {/* Meta Keywords (split meta_description into individual keywords) */}
        <meta name="keywords" content={keywords.join(", ")} />

        {/* Open Graph Meta Tags for Social Media */}
        <meta property="og:title" content={post?.meta_title} />
        <meta property="og:description" content={post?.short_description} />
        <meta property="og:image" content={post?.title_image} />
        <meta
          property="og:url"
          content={`https://www.eksiogluhukukofisi.com/blog/${post?.slug}`}
        />
        <meta property="og:type" content="article" />

        {/* Twitter Meta Tags for Twitter Cards */}
        <meta name="twitter:title" content={post?.meta_title} />
        <meta name="twitter:description" content={post?.short_description} />
        <meta name="twitter:image" content={post?.title_image} />
        <meta name="twitter:card" content="summary_large_image" />

        {/* Additional SEO Tags */}
        <meta name="robots" content="index, follow" />
        <meta
          property="article:published_time"
          content={post?.date_published}
        />
        <meta property="article:modified_time" content={post?.created_date} />
        <link
          rel="canonical"
          href={`https://www.eksiogluhukukofisi.com/blog/${post?.slug}`}
        />
      </Helmet>
      <WhiteNavbar />
      <div style={{ height: !toggleWidth && "3em" }}></div>
      <div className="section">
        <Container>
          <Row>
            <Col
              xl={toggled ? "12" : "3"}
              className="section hideScroll widthResponsive"
              style={{
                position: toggled ? "relative" : "sticky",
                top: toggled ? undefined : "88px",
                alignSelf: "flex-start",
                height: toggled ? "auto" : "auto",
                maxHeight: toggled ? "none" : "calc(100vh - 100px)",
                overflowY: toggled ? "visible" : "auto",
                width: toggled ? "100%" : "90%",
                zIndex: toggled ? 999 : "auto",
                transition: "all 0.3s ease-in-out",
                paddingTop: 0,
              }}
            >
              <Sidebar
                backgroundColor={toggled ? "#ffffff" : undefined}
                onClick={() => setToggled(false)}
                toggled={toggled}
                breakPoint="xl"
                className="deneme"
                style={{
                  border: "none",
                  height: "100%",
                }}
                rootStyles={{
                  height: "100%",
                }}
              >
                <h2
                  className=" text-center baslık font-sans"
                  style={{
                    background: "linear-gradient(135deg, #0F172A, #333333)",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    marginTop: "0",
                    fontWeight: "bold",
                    paddingBottom: "20px",
                    border: "none !important",
                    color: "#095891",
                    fontSize: "32px",
                  }}
                >
                  {" "}
                  Güncel Yazılar
                </h2>
                <Menu
                  closeOnClick="true"
                  menuItemStyles={{
                    button: ({ level, active }) => {
                      // only apply styles on first level elements of the tree
                      console.log(level);
                      if (level === 0)
                        return {
                          "&:hover": {
                            color: active ? "white" : "black",
                            backgroundColor: active ? "#095891" : undefined,
                          },
                          backgroundColor: active ? "#095891" : undefined,
                          color: active ? "white" : "black",
                          zIndex: "5",
                          borderRadius: "12px",
                          padding: "15px",
                        };
                    },
                    label: { whiteSpace: "normal" },
                  }}
                >
                  {reversedData?.map((post, index) => {
                    return (
                      <MenuItem
                        component={
                          <Link
                            to={"/blog/" + post?.slug}
                            onClick={() => window.scrollTo(0, 0)}
                          />
                        }
                        active={window.location.href.endsWith(
                          "/blog/" + post?.slug
                        )}
                        style={{ height: "auto" }}
                        className="font-sans"
                      >
                        {post.title}
                      </MenuItem>
                    );
                  })}
                </Menu>
              </Sidebar>
            </Col>

            <Col
              className={`col-xl-9 custom-col ${toggled ? "toggled" : ""}`}
              style={{
                marginLeft: toggled ? "0" : "auto",
                transition: "all 0.3s ease-in-out",
              }}
            >
              <Card className="card-plain card-blog">
                <div className="card-image">
                  <a href="#pablo" onClick={(e) => e.preventDefault()}>
                    <img
                      alt="..."
                      className="img img-raised rounded"
                      src={post?.title_image}
                    ></img>
                  </a>
                </div>
                <div
                  className="blog-content image-style-align-center"
                  style={{ textAlign: "justify" }}
                >
                  <h1
                    className="title font-sans"
                    style={{
                      fontSize: window.innerWidth < 768 ? "1.3rem" : "2.1rem",
                      marginBottom: "20px",
                      textAlign: "left",
                    }}
                  >
                    {post?.title}
                  </h1>
                  <div
                    style={{ textAlign: "left" }}
                    className="text-[12px] font-sans"
                  >
                    {ReactHtmlParser(post?.content)}
                  </div>
                </div>
                <br></br>
                <div className="flex flex-col items-center gap-4">
                  <div className="flex flex-row gap-8 justify-center items-center">
                    {post?.id !== posts?.[posts.length - 1].id && (
                      <a
                        href={`/blog/${nextPost?.slug}`}
                        style={{ display: "inline-block", height: "2rem" }}
                        className="flex flex-row items-center text-blue-500"
                      >
                        <AiFillBackward size={30} />
                        <span>
                          <strong>Önceki Post</strong>
                        </span>
                      </a>
                    )}

                    {post?.id !== posts?.[0].id && (
                      <a
                        href={`/blog/${previousPost?.slug}`}
                        style={{ display: "inline-block", height: "2rem" }}
                        className="flex flex-row  items-center text-blue-500"
                      >
                        <strong>Sonraki Post</strong>
                        <AiFillForward size={30} />
                      </a>
                    )}
                  </div>

                  {toggleWidth && (
                    <Button
                      className="sb-button text-center "
                      style={{ backgroundColor: "#095891" }}
                      onClick={() => setToggled(!toggled)}
                    >
                      Güncel Yazılar
                    </Button>
                  )}
                </div>
                <br></br>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
      <Footer />
    </div>
  );
};

export default PostFrameworkUpdated;
